var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"fixed-aspect-spanner relative",class:_vm.hFull ? 'h-full' : '',style:({ paddingTop: _vm.paddingTop })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }